import {placeholderCatalog} from "../../../constants/placeholderCatalog";

export function renderTemplate(body, values) {
    if (!body) return "";

    let processed = body;

    // Replace tiptap placeholders (<span data-ph="KEY">...</span>)
    processed = processed.replace(
        /<span[^>]*data-ph="([^"]+)"[^>]*>.*?<\/span>/g,
        (match, key) =>
            values[key] != null && values[key] !== "" ? String(values[key]) : `[niet invullen]`
    );

    // Replace legacy {{KEY}}
    return processed.replace(/\{\{([A-Z0-9_]+)\}\}/g, (m, key) =>
        values[key] == null || values[key] === "" ? `[niet invullen]` : String(values[key])
    );
}

export function exportToTemplateString(html) {
    if (!html) return html;

    return html.replace(
        /<span[^>]*data-ph="([^"]+)"[^>]*>.*?<\/span>/g,
        (match, key) => `{{${key}}}`
    );
}

export function migrateLegacyPlaceholders(html) {
    if (!html) return html;
    const allPlaceholders = placeholderCatalog.flatMap((cat) => cat.placeholders);

    return html.replace(/\{\{([A-Z0-9_]+)\}\}/g, (match, key) => {
        const found = allPlaceholders.find((p) => p.key === key);
        const label = found ? found.label : `Onbekend veld (${key})`;
        return `<span data-ph="${key}" data-label="${label}">${label}</span>`;
    });
}
